const OrderStatus = [
  {
    statusCode: 'CONFIRMED',
    statusName: 'orders.toConfirm',
    statusVariant: 'danger',
    statusOrder: 1,
  },
  {
    statusCode: 'TO_ORDER',
    statusName: 'orders.toOrder',
    statusVariant: 'danger',
    statusOrder: 2,
  },
  {
    statusCode: 'OPENED',
    statusName: 'orders.opened',
    statusVariant: 'warning',
    statusOrder: 3,
  },
  {
    statusCode: 'EMAIL_SENT',
    statusName: 'orders.emailSent',
    statusVariant: 'warning',
    statusOrder: 4,
  },
  {
    statusCode: 'IN_RECEPTION',
    statusName: 'orders.inReception',
    statusVariant: 'warning',
    statusOrder: 5,
  },
  {
    statusCode: 'ORDERED',
    statusName: 'orders.ordered',
    statusVariant: 'success',
    statusOrder: 6,
  },
  {
    statusCode: 'CLOSED',
    statusName: 'orders.closed',
    statusVariant: 'secondary',
    statusOrder: 7,
  },
];

const ReceptionStatus = [
  {
    statusCode: 'CONFIRMED',
    statusName: 'orders.toConfirm',
    statusVariant: 'danger',
    statusOrder: 1,
  },
  {
    statusCode: 'OPENED',
    statusName: 'orders.opened',
    statusVariant: 'warning',
    statusOrder: 3,
  },
  {
    statusCode: 'EMAIL_SENT',
    statusName: 'orders.emailSent',
    statusVariant: 'warning',
    statusOrder: 4,
  },
  {
    statusCode: 'IN_RECEPTION',
    statusName: 'orders.inReception',
    statusVariant: 'warning',
    statusOrder: 5,
  },
  {
    statusCode: 'ORDERED',
    statusName: 'orders.ordered',
    statusVariant: 'success',
    statusOrder: 6,
  },
  {
    statusCode: 'CLOSED',
    statusName: 'orders.closed',
    statusVariant: 'secondary',
    statusOrder: 7,
  },
];

const InventoryStatus = [
  {
    statusCode: 'REQUESTED',
    statusName: 'items.requested',
    statusVariant: 'secondary',
    statusOrder: 3,
  },
  {
    statusCode: 'ORDERED',
    statusName: 'items.ordered',
    statusVariant: 'secondary',
    statusOrder: 4,
  },
  {
    statusCode: 'LOW',
    statusName: 'general.low',
    statusVariant: 'warning',
    statusOrder: 2,
  },
  {
    statusCode: 'CRITICAL',
    statusName: 'general.critical',
    statusVariant: 'danger',
    statusOrder: 1,
  },
  {
    statusCode: 'GOOD',
    statusName: 'general.good',
    statusVariant: 'success',
    statusOrder: 5,
  },
];

const WorkOrderStatus = [
  {
    statusCode: 'MANAGEMENT_NEEDED',
    statusName: 'general.actionNeeded',
    statusVariant: 'danger',
    statusOrder: 1,
  },
  {
    statusCode: 'MANAGEMENT_DONE',
    statusName: 'general.waiting',
    statusVariant: 'warning',
    statusOrder: 2,
  },
  {
    statusCode: 'RESERVATION_DONE',
    statusName: 'general.ready',
    statusVariant: 'success',
    statusOrder: 3,
  },
  {
    statusCode: 'EMPTY',
    statusName: 'general.empty',
    statusVariant: 'secondary',
    statusOrder: 4,
  },
  {
    statusCode: 'DONE',
    statusName: 'general.done',
    statusVariant: 'success',
    statusOrder: 5,
  },
];

const WorkOrderItemStatus = [
  {
    statusCode: 'MANAGEMENT_NEEDED',
    statusName: 'items.managementNeeded',
    statusVariant: 'danger',
    statusOrder: 1,
  },
  {
    statusCode: 'WAITING',
    statusName: 'general.waiting',
    statusVariant: 'warning',
    statusOrder: 2,
  },
  {
    statusCode: 'READY',
    statusName: 'general.ready',
    statusVariant: 'secondary',
    statusOrder: 3,
  },
  {
    statusCode: 'IN_PROGRESS',
    statusName: 'general.inProgress',
    statusVariant: 'warning',
    statusOrder: 4,
  },
  {
    statusCode: 'CONSUMED',
    statusName: 'items.consumed',
    statusVariant: 'success',
    statusOrder: 5,
  },
];

export const DefaultReturnValue = {
  statusCode: 'ERROR',
  statusName: 'errors.error',
  statusVariant: 'danger',
};

const getListFromCode = (code) => {
  switch (code) {
    case 'Inventory':
      return InventoryStatus;
    case 'Orders':
      return OrderStatus;
    case 'Receptions':
      return ReceptionStatus;
    case 'WorkOrders':
      return WorkOrderStatus;
    case 'WorkOrderItems':
      return WorkOrderItemStatus;
    default:
      return [];
  }
};

export default {
  methods: {
    getStatusFromCode(code, listCode) {
      let list = getListFromCode(listCode);
      let currentStatus = list.find((x) => x.statusCode == code);
      if (currentStatus != undefined) {
        return currentStatus;
      }

      return DefaultReturnValue;
    },
    getInventoryStatus() {
      return InventoryStatus;
    },
    getOrderStatus() {
      return OrderStatus;
    },
    getReceptionStatus() {
      return ReceptionStatus;
    },
    getWorkOrderStatus() {
      return WorkOrderStatus;
    },
    getWorkOrderItemStatus() {
      return WorkOrderItemStatus;
    },
  },
};
